module.exports = __webpack_public_path__ + "static/unicorn-87161c6748799c11419fe2a4dc71c125.jpg";